module.exports = __webpack_public_path__ + "media/images/flags/64/Cook-Islands-9e6a67d0e7fea25d612beb7ac8dc9c5f.png";